import { SearchResultDTOTypeEnum, SloDTO } from '@atlassiansox/phobos-client-ts';
import React, { FC, useContext, useState } from 'react';

import { entityLinkDefaultClassName } from '@/components/primitive';
import { SearchConfigContext, SearchViewType } from '@/controllers/search-config-controller';
import { tableExpandContentStyles } from '@/styles';
import { useFeatureGatesController } from '@/controllers';

import * as stylesSearch from '../search-layouts/styles';
import { isIndicatorTypeMimir } from '../../slo-group/utils';

import SearchListSLOCard from './search-list-cards/search-list-slo-card';
import SearchListSLOGroupCard from './search-list-cards/search-list-slo-group-card';
import SearchListType from './search-list-titles/search-list-type';
import SearchListName from './search-list-titles/search-list-name';
import SearchListStatus from './search-list-titles/search-list-status';
import SearchListInfo from './search-list-titles/search-list-info';
import SearchListCapabilityCard from './search-list-cards/search-list-capability-card';
import SearchListBasicCard from './search-list-cards/search-list-basic-card';
import * as styles from './styles';
import { SearchResultItemType } from './types';

type SearchListItemProps = {
  item: SearchResultItemType;
  type: SearchResultDTOTypeEnum;
};

const SearchListItem: FC<SearchListItemProps> = ({ item, type }) => {
  const { allowMimirSLO } = useFeatureGatesController();

  const { searchViewType } = useContext(SearchConfigContext);
  const isComfortView: boolean = searchViewType === SearchViewType.ComfortView;

  const { publicId } = item;

  const [isOpen, setIsOpen] = useState(false);

  const handleToggle = (e: React.MouseEvent<HTMLElement>) => {
    // not to expand / collapse card if the click is on href link
    if ((e.target as HTMLElement).classList.contains(entityLinkDefaultClassName)) return;
    setIsOpen(!isOpen);
  };

  let card;

  switch (type) {
    case SearchResultDTOTypeEnum.Slo: {
      card = <SearchListSLOCard id={publicId} />;
      break;
    }
    case SearchResultDTOTypeEnum.SloGroup: {
      card = <SearchListSLOGroupCard id={publicId} />;
      break;
    }
    case SearchResultDTOTypeEnum.Capability: {
      card = <SearchListCapabilityCard id={publicId} />;
      break;
    }
    case SearchResultDTOTypeEnum.Team: {
      card = <SearchListBasicCard type="team" id={publicId} />;
      break;
    }
    case SearchResultDTOTypeEnum.Product: {
      card = <SearchListBasicCard type="product" id={publicId} />;
      break;
    }
  }

  const isSLOGroup: boolean = type === SearchResultDTOTypeEnum.SloGroup;
  if (isSLOGroup && isIndicatorTypeMimir((item as SloDTO)?.indicator) && !allowMimirSLO) {
    return null;
  }

  return (
    <li>
      <div
        css={[
          stylesSearch.searchResultRowStyles,
          isComfortView ? stylesSearch.searchResultRowComfortStyles : '',
        ]}
        onClick={handleToggle}
      >
        <SearchListType isCardExpanded={isOpen} type={type} item={item} />
        <SearchListName item={item} type={type} isComfortView={isComfortView} />
        {isSLOGroup ? <div>&nbsp;</div> : <SearchListStatus item={item} type={type} />}
        {!isComfortView && <SearchListInfo item={item} type={type} />}
      </div>
      {isOpen && <div css={[styles.cardContentStyles, tableExpandContentStyles]}>{card}</div>}
    </li>
  );
};

export default SearchListItem;
